import { BUSINESS, WA_DEFAULT_MSG } from "@/constants/business";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[var(--tt-cream)]"
    >
      {/* Decorative tape */}
      <div className="absolute -left-10 top-20 w-[360px] h-8 tape opacity-90 rotate-[-6deg]" />
      <div className="absolute -right-10 bottom-12 w-[280px] h-6 tape opacity-80 rotate-[8deg]" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-12 pb-20 lg:pt-20 lg:pb-32 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 rise">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[var(--tt-green-800)]/10 text-[var(--tt-green-800)] text-xs font-bold uppercase tracking-[0.18em]">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--tt-orange)]" />
            Kilis Merkez
          </div>

          <h1 className="font-display text-[44px] sm:text-6xl lg:text-7xl leading-[0.95] mt-5 text-[var(--tt-green-900)]">
            Hırdavatta güç,
            <br />
            geri dönüşümde
            <span className="relative inline-block ml-3">
              <span className="relative z-10 text-[var(--tt-cream)] px-3">vicdan.</span>
              <span className="absolute inset-0 bg-[var(--tt-orange)] -rotate-1 rounded-md" />
            </span>
          </h1>

          <p className="mt-6 text-base sm:text-lg max-w-xl text-[var(--tt-charcoal)]/75 leading-relaxed">
            <span className="font-bold text-[var(--tt-green-900)]">Tuncay Ticaret</span>,
            Kilis Merkez&apos;de hırdavat ihtiyacınızı karşılayan ve metal/atık geri
            dönüşümünü ilkeli biçimde yapan güvenilir ticarethanedir. Doğru malzeme,
            adil fiyat, hızlı çözüm.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3">
            <a
              data-testid="hero-cta-whatsapp"
              href={`https://wa.me/${BUSINESS.phones[0].whatsapp}?text=${encodeURIComponent(WA_DEFAULT_MSG)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white font-bold rounded-full pl-5 pr-6 py-3.5 transition-colors shadow-lg shadow-[#25D366]/20"
            >
              <svg viewBox="0 0 32 32" className="w-5 h-5 fill-current" aria-hidden="true">
                <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.788 2.722.788.817 0 2.15-.515 2.45-1.318.158-.43.158-.802.115-.93-.072-.214-.387-.33-.616-.45-.703-.348-1.575-.83-1.875-.83zM16 7.105a8.95 8.95 0 0 0-7.6 13.62L7.2 25l4.4-1.16A8.95 8.95 0 1 0 16 7.105z" />
              </svg>
              WhatsApp ile Yaz
            </a>
            <a
              data-testid="hero-cta-call"
              href={`tel:${BUSINESS.phones[0].tel}`}
              className="inline-flex items-center gap-2 border-2 border-[var(--tt-green-800)] text-[var(--tt-green-800)] hover:bg-[var(--tt-green-800)] hover:text-white font-bold rounded-full pl-5 pr-6 py-3 transition-colors"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              Hemen Ara
            </a>
          </div>

          {/* trust strip */}
          <div className="mt-10 grid grid-cols-3 max-w-md gap-6">
            {[
              { v: "Adil", l: "Fiyat" },
              { v: "Hızlı", l: "Teslim" },
              { v: "Çevreci", l: "İlke" },
            ].map((s) => (
              <div key={s.l}>
                <div className="font-display text-2xl text-[var(--tt-green-800)]">{s.v}</div>
                <div className="text-[11px] uppercase tracking-widest text-[var(--tt-steel)] mt-1">{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right - Logo card */}
        <div className="lg:col-span-5 rise" style={{ animationDelay: "0.15s" }}>
          <div className="relative">
            <div className="absolute -inset-6 bg-[var(--tt-orange)]/15 rounded-[32px] blur-2xl" />
            <div className="relative rounded-[28px] bg-white border border-black/5 shadow-2xl p-8 sm:p-10">
              <img
                src="/assets/logo-cropped.jpg"
                alt="Tuncay Ticaret"
                data-testid="hero-logo"
                className="w-full h-auto object-contain rounded-2xl"
              />
              <div className="mt-6 flex items-center justify-between text-sm">
                <div className="flex items-center gap-2 text-[var(--tt-green-800)] font-bold">
                  <span className="w-2 h-2 rounded-full bg-[var(--tt-green-500)] animate-pulse" />
                  Açığız
                </div>
                <div className="text-[var(--tt-steel)] font-semibold">
                  Pzt - Cmt
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="border-y-2 border-[var(--tt-green-900)] bg-[var(--tt-green-900)] text-[var(--tt-cream)] overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap py-4 text-sm font-bold uppercase tracking-[0.25em]">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="flex items-center shrink-0">
              {[
                "Demir & Çelik",
                "Bakır • Pirinç • Alüminyum",
                "Hırdavat Malzemeleri",
                "Geri Dönüşüm",
                "Hurda Alımı",
                "El Aletleri",
                "Yapı Gereçleri",
                "Kilis Merkez",
              ].map((t) => (
                <span key={t + i} className="px-8 flex items-center gap-8 shrink-0">
                  {t}
                  <span className="w-2 h-2 rounded-full bg-[var(--tt-orange)]" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
